<script setup lang="ts">
import { toRef } from 'vue';

import VDropdownMenu from '@components/dropdowns/VDropdownMenu/VDropdownMenu.vue';
import VLoader from '@components/loader/VLoader.vue';

import type {
  IGroupByParamsEmits,
  IGroupByParamsProps,
} from './types';
import { useGroupByParams } from './composables';

const props = defineProps<IGroupByParamsProps>();
const emit = defineEmits<IGroupByParamsEmits>();

const {
  groups,
  onChange,
} = useGroupByParams(
  toRef(props, 'groupOptions'),
  toRef(props, 'availableGroups'),
  toRef(props, 'translationKey'),
  emit,
);
</script>

<template>
  <VLoader v-data-qa-auto-id="'VGroupByParams'"
    :loading="isLoading"
    mode="structural"
    min-height="37.5px"
    spinner-size="small"
    spinner-wrapper-class="w-full"
  >
    <div class="flex items-start gap-2 max-md:flex-col">
      <template v-for="(value, key) in groups">
        <VDropdownMenu
          v-if="value?.length"
          :key="key"
          :options="value"
          :value="groupValues[key]"
          class="min-w-0 flex-none"
          :name="key"
          style-type="dark"
          zero-min-width
          @change="(value) => onChange(key, value)"
        />
      </template>
    </div>
  </VLoader>
</template>
